export const fonts = () => ({
	fonts: {
		manifa: `'ManifaPro2', sans-serif`,
		ghawar: `'Ghawar', sans-serif`,
	}
})
